import AbstractPolygon from './../AbstractPolygon';
import ChinaProvinceData from './data.json';
/**
 * 全国省份围栏类
 */
export default class ChinaProvincePolygon extends AbstractPolygon {
    constructor(opts) {
        super(opts, ChinaProvinceData)
    }
}